// Component-level DOM container constants (not route-specific)
export const REACTDOM_CONTAINERS = {
  TOOLTIP: 'tooltipContainer',
  DROPDOWN: 'dropdownContainer',
};

export const LAYER_PRIORITY = {
  'DEFAULT': 400,
  'MODAL_DROPDOWN': 950,
};

export const CONTAINERS = {
  TOOLTIP: `#${REACTDOM_CONTAINERS.TOOLTIP}`,
  DROPDOWN: `#${REACTDOM_CONTAINERS.DROPDOWN}`,
};
